module.exports = __webpack_public_path__ + "static/media/oren.480c9bb7.png";